export default "__VITE_ASSET__BXxo8Wpt__"